import { UserOpResponse } from '@biconomy/account'
import { GasPrice, TransactionStatus } from '@kwenta/sdk/types'
import { toast } from 'react-toastify'
import { Hex } from 'viem'

import { NotificationError } from 'components/TransactionNotification'
import sdk from 'state/sdk'
import { AppDispatch } from 'state/store'

import { updateTransactionHash, updateTransactionStatus } from './reducer'

export const serializeGasPrice = (gasPrice: GasPrice): GasPrice<string> => ({
	baseFeePerGas: gasPrice.baseFeePerGas?.toString() ?? '0',
	maxPriorityFeePerGas: gasPrice.maxPriorityFeePerGas?.toString() ?? '0',
	maxFeePerGas: gasPrice.maxFeePerGas?.toString() ?? '0',
	gasPrice: gasPrice.gasPrice?.toString() ?? '0',
})

export const unserializeGasPrice = (gasPrice: GasPrice<string>): GasPrice => ({
	baseFeePerGas: BigInt(gasPrice.baseFeePerGas ?? 0),
	maxPriorityFeePerGas: BigInt(gasPrice.maxPriorityFeePerGas ?? 0),
	maxFeePerGas: BigInt(gasPrice.maxFeePerGas ?? 0),
	gasPrice: BigInt(gasPrice.gasPrice ?? 0),
})

export const monitorAndAwaitTransaction = async (dispatch: AppDispatch, txHash: Hex) => {
	dispatch(updateTransactionHash(txHash))
	await sdk.context.client.waitForTransactionReceipt({ hash: txHash })
	dispatch(updateTransactionStatus(TransactionStatus.Confirmed))
}

export const monitorAndAwaitUserOp = async (dispatch: AppDispatch, response: UserOpResponse) => {
	const { transactionHash } = await response.waitForTxHash()
	dispatch(updateTransactionHash(transactionHash as Hex))
	const result = await response.wait()

	if (result.success === 'false') {
		dispatch(updateTransactionStatus(TransactionStatus.Failed))
		throw new Error('Transaction reverted')
	}

	dispatch(updateTransactionStatus(TransactionStatus.Confirmed))
}

export const monitorFollowingTransaction = async (originTxHash: Hex, txHash: Hex) => {
	const emitter = sdk.transactions.hash(txHash)
	emitter.on('txFailed', ({ failureReason }) => {
		toast.update(originTxHash, {
			containerId: 'notifications',
			render: <NotificationError failureReason={failureReason} />,
			hideProgressBar: false,
			progressClassName: 'failProgress',
			autoClose: 10000,
		})
	})
}
